import { use } from 'echarts/lib/echarts';
import { install } from './map3D/install';
use(install);